import type { DeepWriteable } from '~/types/utility'

export const useWritableRef = <T>(value: T) => {
  return ref<DeepWriteable<T>>(value)
}
